import { Feature, UserRole } from "../models/enums";
import { isFeatureEnabled } from "../services/featureSwitchService";

export const useFeatureSwitch = (feature: Feature, userRole: UserRole) => {
  return isFeatureEnabled(feature, userRole);
};
